import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  VStack,
  FormControl,
  FormLabel,
  useToast
} from "@chakra-ui/react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import DatePickerLabel from "../DatePickerLabel";

const NoteEditorModal = ({ isOpen, onClose, onSave, initialNote }) => {
  const [text, setText] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [notifyDate, setNotifyDate] = useState("");
  const toast = useToast();

  const handleSave = () => {
    const today = new Date();

    if(!dueDate || !notifyDate || !text){
      toast({title: "กรุณากรอกข้อมูลให้ครบ", status: "warning", duration: 3000, isClosable: true,});
    }
    else if (new Date(dueDate) <= today) {
      toast({title: "วันกิจกรรมต้องเป็นวันหลังจากวันนี้", status: "warning", duration: 3000,isClosable: true,});
    } 
    else if (notifyDate && dueDate && new Date(notifyDate) > new Date(dueDate)) {
      toast({title: "วันแจ้งเตือนต้องมาก่อนวันกิจกรรม", status: "warning", duration: 3000, isClosable: true,});
    }
    else{
      onSave(text, dueDate, notifyDate);
      onClose();
    }
  };

  const setNotifyDay = (val) => {
    setNotifyDate(val);
  };

  const setDueDay = (val) => {
    setDueDate(val);

    if (val) {
      const sevenDaysBeforeDueDate = new Date(val);
      //sevenDaysBeforeDueDate.setDate(sevenDaysBeforeDueDate.getDate() - 7);

      if(!notifyDate){
        setNotifyDate(sevenDaysBeforeDueDate.toISOString().split('T')[0]);
      }
    }
  };

  useEffect(()=>{
    setText(initialNote ? initialNote.note : "");
    setDueDate(initialNote ? initialNote.due_date : "");
    setNotifyDate(initialNote ? initialNote.notify_date : "");
  },[initialNote])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>กิจกรรม/บันทึกช่วยจำ</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={2}>
            <FormControl>
              <FormLabel>กิจกรรม/บันทึก สำหรับวันที่</FormLabel>
              <DatePickerLabel
                setSelectedDay={setDueDay}
                initDateStr={dueDate}
              />
            </FormControl>
            <FormControl>
              <FormLabel>ให้เริ่มแสดงการแจ้งเตือน (ระบุวันที่)</FormLabel>
              <DatePickerLabel
                setSelectedDay={setNotifyDay}
                initDateStr={notifyDate}
              />
            </FormControl>
            <FormControl>
              <FormLabel>รายละเอียด</FormLabel>
              <ReactQuill
                style={{ height: "200px" }}
                value={text}
                onChange={(value) => setText(value)}
                modules={{
                  toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["link"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ align: [] }],
                  ],
                }}
                formats={[
                  "bold",
                  "italic",
                  "underline",
                  "strike",
                  "link",
                  "list",
                  "bullet",
                  "align",
                ]}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Flex mt={8}>
            <Button colorScheme="blue" onClick={handleSave}>
              บันทึก
            </Button>
            <Button variant="ghost" onClick={onClose}>
              ยกเลิก
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NoteEditorModal;
